import { render, staticRenderFns } from "./PhotoPostView.vue?vue&type=template&id=624f644a"
import script from "./PhotoPostView.vue?vue&type=script&lang=js"
export * from "./PhotoPostView.vue?vue&type=script&lang=js"
import style0 from "./PhotoPostView.vue?vue&type=style&index=0&id=624f644a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports